(function () {
    function getAntiForgeryToken() {
        const tokenInput = document.querySelector('#product-selector-antiforgery input[name="__RequestVerificationToken"]');
        return tokenInput?.value ?? null;
    }
    // -----------------------------
    // STEP 1: Vehicle card selection
    // -----------------------------
    document.addEventListener('change', async (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches('input.js-vehicle-radio[type="radio"]')) return;

        const ctx = getStepContext();
        if (!ctx) return;

        const { pageId } = ctx;

        const vehicleJson = input.dataset.vehicleJson;
        if (!vehicleJson) return;

        let vehicle;
        try {
            vehicle = JSON.parse(vehicleJson);
        } catch {
            console.error('Invalid vehicle JSON on selected input.');
            return;
        }

        const selectorSection = document.querySelector('#selector-section');
        if (!selectorSection) return;

        const selectedVehicleDefinition = safeParseJsonDataset(selectorSection, 'selectedVehicleDefinition');

        //if vehicle definition already selected and it's the same type as the newly selected vehicle, keep any potential selected specs,
        if (selectedVehicleDefinition && selectedVehicleDefinition.VehicleType.VehicleTypeId == vehicle.VehicleType.VehicleTypeId) {
            const selectedVehicle = safeParseJsonDataset(selectorSection, 'selectedVehicle');
            const selectedProduct = safeParseJsonDataset(selectorSection, 'selectedProduct');
            const selectedProductApplication = safeParseJsonDataset(selectorSection, 'selectedProductApplication');

            const body = {
                pageId: pageId,
                step: 'VehicleSpecs',
                selectedVehicleDefinition,
                selectedVehicle,
                selectedProduct,
                selectedProductApplication
            };

            advanceStep(JSON.stringify(body), false);
        }
        else {

            var requestBody = JSON.stringify({
                pageId: pageId,
                step: 'VehicleSpecs',
                selectedVehicleDefinition: vehicle
            });
            advanceStep(requestBody, false);
        }
    });

    // -----------------------------
    // STEP 2: Spec dropdown changes
    // -----------------------------
    function getSpecContainerFromTarget(target) {
        if (!(target instanceof Element)) return null;
        return target.closest('.spec-grid');
    }

    function getSpecSelects(specContainer) {
        return Array.from(specContainer.querySelectorAll('select.spec-select'));
    }

    function buildSelectedSpecs(selects, upToIndexInclusive) {
        const selected = {};
        const selectedSpecSpan = document.querySelector('#selected-specs-span');
        var specText = '';
        for (let i = 0; i <= upToIndexInclusive; i++) {
            const sel = selects[i];
            const specName = sel.dataset.id;
            const value = sel.value;

            if (specName && value) {
                selected[specName] = escapeHtml(value);
                specText += `${String(escapeHtml(value))} `;
                if (specName == 'Model') {
                    specText += '<br/>'
                }
            }
        }

        if (selectedSpecSpan) {
            selectedSpecSpan.innerHTML = specText.trim();
        }
        return selected;
    }

    function resetDownstream(selects, startIndex) {
        for (let i = startIndex; i < selects.length; i++) {
            const sel = selects[i];

            const placeholderText =
                sel.querySelector('option[disabled]')?.textContent?.trim() ??
                'Select';

            sel.innerHTML = `<option value="" selected disabled hidden data-filter-value="">${placeholderText}</option>`;
            sel.value = '';
            sel.disabled = true;
        }
    }

    async function loadOptions(vehicleTypeId, specName, selectedSpecs) {
        const url = new URL('/api/product-selector/vehicles/specs', window.location.origin);
        url.searchParams.set('vehicleTypeId', vehicleTypeId);
        url.searchParams.set('specName', specName);

        Object.entries(selectedSpecs).forEach(([k, v]) => {
            url.searchParams.append(`selectedSpecs[${k}]`, v);
        });
        const antiForgeryToken = getAntiForgeryToken();

        const res = await fetch(url.toString(), {
            headers: {
                'Accept': 'application/json', ...(antiForgeryToken ? { 'RequestVerificationToken': antiForgeryToken } : {})
            }
        });
        if (!res.ok) {
            const text = await res.text();
            throw new Error(`Spec request failed (${res.status}): ${text}`);
        }

        return await res.json();
    }

    document.addEventListener('change', async (e) => {
        const changed = e.target;
        if (!(changed instanceof HTMLSelectElement)) return;
        if (!changed.matches('select.spec-select')) return;

        const specContainer = getSpecContainerFromTarget(changed);
        if (!specContainer) return;

        const selects = getSpecSelects(specContainer);
        const index = selects.indexOf(changed);
        if (index < 0) return;

        resetDownstream(selects, index + 1);

        const next = selects[index + 1];
        if (!next) {
            const selectedVehicleSpecs = buildSelectedSpecs(selects, index);
            advanceToProductSelection(selectedVehicleSpecs);
            return;
        }

        const vehicleTypeId = changed.dataset.vehicleTypeId;
        if (!vehicleTypeId) return;
        if (!changed.value) return;

        const nextSpecName = next.dataset.id;
        if (!nextSpecName) return;

        const selectedSpecs = buildSelectedSpecs(selects, index);

        try {
            const nextPlaceholderText =
                changed.dataset.placeholderText ??
                'Select';

            // Show "loading" state immediately and keep it from being selectable
            next.disabled = true;
            next.innerHTML = `<option value="" selected disabled hidden data-filter-value="">...</option>`;

            const specs = await loadOptions(vehicleTypeId, nextSpecName, selectedSpecs);

            next.innerHTML = `
                <option value="" selected disabled hidden data-filter-value="">${nextPlaceholderText}</option>
                ${specs.map(s => `<option value="${String(s.value)}" data-filter-value="${String(s.value)}">${String(s.displayText)}</option>`).join('')}
            `;

            next.disabled = false;

            // Auto-select if there's exactly one real option (excluding the placeholder)
            const realOptions = Array.from(next.options).filter(o => !o.disabled && o.value !== '');
            if (realOptions.length === 1) {
                next.value = realOptions[0].value;
                next.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } catch (err) {
            console.error('Failed to load next spec options:', err);
        }
    });

    async function advanceToProductSelection(selectedSpecs) {
        try {
            const ctx = getStepContext();
            if (!ctx) return;

            const { stepHost, pageId, selectorSection } = ctx;

            var requestBody = JSON.stringify({
                pageId: pageId,
                step: 'Product',

                selectedSpecs: selectedSpecs,
                selectedVehicleDefinition: JSON.parse(selectorSection.dataset.selectedVehicleDefinition)
            });
            advanceStep(requestBody, false);

        } catch (err) {
            console.error('Failed to advance step:', err);
        }
    }

    // -----------------------------
    // STEP 3: Select Products - grouping, filtering, and modals
    // -----------------------------
    function parseJsonAttr(el, attrName) {
        const raw = el.getAttribute(attrName);
        if (!raw) return null;
        try { return JSON.parse(raw); } catch { return null; }
    }

    function escapeHtml(s) {
        return String(s)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#39;');
    }

    function normalizeFacet(f) {
        // Support both camelCase and PascalCase payloads
        return {
            name: (f?.name ?? f?.Name ?? '').toString(),
            value: (f?.value ?? f?.Value ?? '').toString(),
            sort: Number(f?.sort ?? f?.Sort ?? 0)
        };
    }

    function getFacetForCard(card, facetName) {
        const facetsRaw = parseJsonAttr(card, 'data-product-facets') || [];
        const facets = facetsRaw.map(normalizeFacet);

        return facets.find(f => f.name === facetName) || null;
    }

    function getProductRowFromSelect(sel) {
        const productGrid = sel.closest('.product-grid');
        if (!productGrid) return null;

        return productGrid.querySelector('.products-row') || null;
    }

    function removeExistingGroupHeaders(row) {
        row.querySelectorAll('.js-product-group-header').forEach(h => h.remove());
    }

    function groupCards(cards, facetName) {
        // groupValue -> { sort: number, cards: Element[] }
        const groups = new Map();

        for (const card of cards) {
            const facet = getFacetForCard(card, facetName);

            const groupValue = facet?.value?.trim() || 'Other';
            const groupSort = facet ? facet.sort : Number.MAX_SAFE_INTEGER;

            if (!groups.has(groupValue)) {
                groups.set(groupValue, { sort: groupSort, cards: [] });
            }
            else {
                // If different products report different Sort values for same group, keep the smallest.
                const entry = groups.get(groupValue);
                entry.sort = Math.min(entry.sort, groupSort);
            }

            groups.get(groupValue).cards.push(card);
        }

        // Sort groups by facet.Sort, then Value text. "Other" always last.
        const keys = Array.from(groups.keys()).sort((a, b) => {
            if (a === 'Other') return 1;
            if (b === 'Other') return -1;

            const sa = groups.get(a).sort;
            const sb = groups.get(b).sort;
            if (sa !== sb) return sa - sb;

            return String(a).localeCompare(String(b));
        });

        // Optional: sort within group by product name for consistency
        for (const key of keys) {
            groups.get(key).cards.sort((x, y) => {
                const nx = x.dataset.productName || '';
                const ny = y.dataset.productName || '';
                return nx.localeCompare(ny);
            });
        }

        return { groups, keys };
    }

    function makeGroupHeaderCol(groupName) {
        const headerCol = document.createElement('div');
        headerCol.className = 'col-12 js-product-group-header';
        headerCol.innerHTML = `<h4 class="mt-3 mb-2 selector-header-span">${escapeHtml(groupName)}</h4>`;
        return headerCol;
    }

    function applyGroupingForRow(row) {
        const stepHost = document.querySelector('#product-selector-step');
        const sel = stepHost?.querySelector('select.js-group-by-facet');
        const facetName = sel?.options?.[sel.selectedIndex]?.textContent?.trim();
        if (!facetName) return;

        removeExistingGroupHeaders(row);

        // Only group visible cards
        const cards = Array.from(row.querySelectorAll(':scope > .js-product-card'))
            .filter(c => c.style.display !== 'none');

        if (!cards.length) return;

        const { groups, keys } = groupCards(cards, facetName);

        // Preserve any hidden cards after visible ones (so we don't lose them)
        const hiddenCards = Array.from(row.querySelectorAll(':scope > .js-product-card'))
            .filter(c => c.style.display === 'none');

        row.innerHTML = '';
        for (const key of keys) {
            row.appendChild(makeGroupHeaderCol(key));
            for (const card of groups.get(key).cards) {
                row.appendChild(card);
            }
        }
        for (const card of hiddenCards) {
            row.appendChild(card);
        }
    }

    document.addEventListener('change', (e) => {
        const sel = e.target;
        if (!(sel instanceof HTMLSelectElement)) return;
        if (!sel.matches('select.js-group-by-facet')) return;

        const facetName = sel.options[sel.selectedIndex]?.textContent?.trim();
        if (!facetName) return;

        const row = getProductRowFromSelect(sel);
        if (!row) return;

        applyGroupingForRow(row);
    });

    function getSelectedFacetFilters(productGrid) {
        // Map<facetName, Set<facetValue>>
        const map = new Map();

        const checked = Array.from(productGrid.querySelectorAll('input.js-facet-checkbox[type="checkbox"]:checked'));
        for (const cb of checked) {
            const facetName = (cb.dataset.facetName ?? '').trim();
            const facetValue = (cb.dataset.facetValue ?? cb.value ?? '').trim();
            if (!facetName || !facetValue) continue;

            if (!map.has(facetName)) map.set(facetName, new Set());
            map.get(facetName).add(facetValue);
        }

        return map;
    }

    function cardMatchesFilters(card, selectedFilters) {
        if (!selectedFilters || selectedFilters.size === 0) return true;

        const facetsRaw = parseJsonAttr(card, 'data-product-facets') || [];
        const facets = facetsRaw.map(normalizeFacet);

        // AND across facet names; OR within the same name
        for (const [facetName, allowedValues] of selectedFilters.entries()) {
            const productValues = facets
                .filter(f => f.name === facetName)
                .map(f => (f.value ?? '').trim())
                .filter(Boolean);

            // If the product doesn't have this facetName at all -> doesn't match
            if (productValues.length === 0) return false;

            // Must match at least one checked value for that facet name
            let any = false;
            for (const v of productValues) {
                if (allowedValues.has(v)) { any = true; break; }
            }
            if (!any) return false;
        }

        return true;
    }

    function applyFacetFiltering(productGrid) {
        const selected = getSelectedFacetFilters(productGrid);

        const row = productGrid.querySelector('.products-row');

        if (!row) return;

        const cards = Array.from(row.querySelectorAll(':scope > .js-product-card'));
        for (const card of cards) {
            const show = cardMatchesFilters(card, selected);
            card.style.display = show ? '' : 'none';
        }

        // Keep group headers consistent with what's visible
        applyGroupingForRow(row);
    }

    document.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches('input.js-facet-checkbox[type="checkbox"]')) return;

        const productGrid = input.closest('.product-grid');
        if (!productGrid) return;

        applyFacetFiltering(productGrid);
    });

    // Call this after any content swap to apply default grouping
    function initDefaultGroupBy() {
        const stepHost = document.querySelector('#product-selector-step');
        if (!stepHost) return;

        const sel = stepHost.querySelector('select.js-group-by-facet');
        if (!sel) return;

        if (sel.selectedIndex < 0 && sel.options.length > 0) {
            sel.selectedIndex = 0;
        }

        sel.dispatchEvent(new Event('change', { bubbles: true }));

        // Also apply filtering if checkboxes exist (e.g., after step HTML swap)
        const productGrid = stepHost.querySelector('.product-grid');
        if (productGrid) applyFacetFiltering(productGrid);
    }

    // Initial page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDefaultGroupBy, { once: true });
    } else {
        initDefaultGroupBy();
    }

    window.productSelectorInit = initDefaultGroupBy;

    document.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        if (!input.matches('input.js-product-radio[type="radio"]')) return;

        const modalId = input.dataset.modalId;
        if (!modalId) return;

        const modalEl = document.getElementById(modalId);
        if (!modalEl) return;

        // Bootstrap 5
        if (window.bootstrap?.Modal) {
            const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
            modal.show();
            return;
        }

        // Bootstrap 4 (jQuery)
        if (window.jQuery && typeof window.jQuery(modalEl).modal === 'function') {
            window.jQuery(modalEl).modal('show');
            return;
        }

        console.warn('No supported Bootstrap modal API found (Bootstrap 5 or jQuery/Bootstrap 4).');
    });

    // Clear selected product radio when its modal is dismissed
    if (window.jQuery) {
        window.jQuery(document).on('hidden.bs.modal hide.bs.modal', '.modal', function () {
            const modalId = this.id;
            if (!modalId) return;

            const stepHost = document.querySelector('#product-selector-step');
            const radio = stepHost?.querySelector(`input.js-product-radio[data-modal-id="${CSS.escape(modalId)}"]`);
            if (!(radio instanceof HTMLInputElement)) return;

            radio.checked = false;
        });
    }


    document.addEventListener('click', async (e) => {
        const btn = e.target instanceof Element ? e.target.closest('button.js-select-options') : null;
        if (!(btn instanceof HTMLButtonElement)) return;

        const ctx = getStepContext();
        if (!ctx) return;

        const { stepHost, pageId, selectorSection } = ctx;

        const productJson = btn.dataset.productJson;
        if (!productJson) {
            console.error('Missing product on Select Options button.');
            return;
        }

        const selectedVehicle = safeParseJsonDataset(selectorSection, 'selectedVehicle');
        const selectedVehicleDefinition = safeParseJsonDataset(selectorSection, 'selectedVehicleDefinition');
        const selectedProduct = safeParseJsonDataset(selectorSection, 'selectedProduct');
        let product;
        try {
            product = JSON.parse(productJson);
        } catch {
            console.error('Invalid vehicle JSON on selected input.');
            return;
        }
        //if product definition already selected and it's the same type as the newly selected product, keep any potential selected options,
        if (selectedProduct && selectedProduct.MainComponent.Item.ItemNumber == product.MainComponent.Item.ItemNumber) {
            const selectedProductApplication = safeParseJsonDataset(selectorSection, 'selectedProductApplication');

            const body = {
                pageId: pageId,
                step: 'Option',
                selectedVehicleDefinition,
                selectedVehicle,
                selectedProduct,
                selectedProductApplication
            };

            advanceStep(JSON.stringify(body), false);
        }
        else {
            var requestBody = JSON.stringify({
                pageId: pageId,
                step: 'Option',
                selectedVehicleDefinition: selectedVehicleDefinition,
                selectedVehicle: selectedVehicle,
                selectedProduct: JSON.parse(productJson),
            });
            advanceStep(requestBody, false);
        }
    });

    function getSelectedOptionalItems(stepHost) {
        return Array.from(stepHost.querySelectorAll('input.js-optional-check[type="checkbox"]:checked'))
            .map(x => (x.value ?? '').trim())
            .filter(Boolean);
    }

    function getSelectedComponents(stepHost) {
        return Array.from(stepHost.querySelectorAll('input.js-product-option-radio[type="radio"]:checked'))
            .map(x => (x.value ?? '').trim())
            .filter(Boolean);
    }

    document.addEventListener('click', async (e) => {
        const btn = e.target instanceof Element ? e.target.closest('button.js-view-summary') : null;
        if (!(btn instanceof HTMLButtonElement)) return;

        const ctx = getStepContext();
        if (!ctx) return;

        const { stepHost, pageId, selectorSection } = ctx;

        const optionalItems = getSelectedOptionalItems(stepHost);
        const selectedComponents = getSelectedComponents(stepHost);

        var requestBody = JSON.stringify({
            pageId: pageId,
            step: 'Summary',
            selectedVehicleDefinition: JSON.parse(selectorSection.dataset.selectedVehicleDefinition),
            selectedVehicle: JSON.parse(selectorSection.dataset.selectedVehicle),
            selectedProduct: JSON.parse(selectorSection.dataset.selectedProduct),
            optionalItems: optionalItems,
            selectedComponents: selectedComponents
        });
        advanceStep(requestBody, true);
    });


    async function advanceStep(requestBody, trackCompleteEvent) {
        const stepHost = document.querySelector('#product-selector-step');
        if (!stepHost) return;
        const loader = document.querySelector('#product-selector-loader');

        const antiForgeryToken = getAntiForgeryToken();

        try {
            if (loader) loader.style.display = 'flex';
            const res = await fetch('/api/product-selector/step', {
                method: 'POST',
                headers: {
                    'Accept': 'text/html',
                    'Content-Type': 'application/json',
                    ...(antiForgeryToken ? { 'RequestVerificationToken': antiForgeryToken } : {})
                },
                body: requestBody
            });

            if (!res.ok) {
                const text = await res.text();
                throw new Error(`Step request failed (${res.status}): ${text}`);
            }

            stepHost.innerHTML = await res.text();
            window.productSelectorInit?.();

            if (window.trackProductSelectorConfiguratorCompleteEvent && trackCompleteEvent) {
                window.trackProductSelectorConfiguratorCompleteEvent();
            }

            if (loader) loader.style.display = 'none';
            setTimeout(function () {
                stepHost.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } catch (err) {
            if (loader) loader.style.display = 'none';
            console.error('Failed to advance step:', err);
        }
    }

    function safeParseJsonDataset(el, key) {
        const raw = el?.dataset?.[key];
        if (!raw) return null;
        try { return JSON.parse(raw); } catch { return null; }
    }

    function stepFromActiveIndex(activeIndex) {
        switch (Number(activeIndex)) {
            case 0: return 'Vehicle';
            case 1: return 'VehicleSpecs';
            case 2: return 'Product';
            case 3: return 'Option';
            default: return 'Vehicle';
        }
    }

    document.addEventListener('click', (e) => {
        const btn =
            e.target instanceof Element
                ? e.target.closest('button.product-stepper-btn, button.js-back-btn, button.js-edit-btn')
                : null;

        if (!(btn instanceof HTMLButtonElement)) return;
        if (btn.disabled) return;

        const ctx = getStepContext();
        if (!ctx) return;

        const { stepHost, pageId, selectorSection } = ctx;

        // Step comes from:
        // - stepper buttons: data-step
        // - edit buttons: data-selector-step
        // - back button: derived from current data-active-step
        let step = btn.dataset.step;

        if (!step && btn.classList.contains('js-edit-btn')) {
            step = btn.dataset.selectorStep;
        }

        if (!step && btn.classList.contains('js-back-btn')) {
            const activeStep = selectorSection.dataset.activeStep; // string
            step = stepFromActiveIndex(activeStep);
        }

        if (!step) return;

        const selectedVehicleDefinition = safeParseJsonDataset(selectorSection, 'selectedVehicleDefinition');
        const selectedVehicle = safeParseJsonDataset(selectorSection, 'selectedVehicle');
        const selectedProduct = safeParseJsonDataset(selectorSection, 'selectedProduct');
        const selectedProductApplication = safeParseJsonDataset(selectorSection, 'selectedProductApplication');

        const body = {
            pageId: pageId,
            step: step,
            selectedVehicleDefinition,
            selectedVehicle,
            selectedProduct,
            selectedProductApplication
        };

        advanceStep(JSON.stringify(body), false);


    });

    // -----------------------------
    // STEP 4: Product Options
    // -----------------------------


    function getSelectorSection() {
        return document.querySelector('#selector-section');
    }

    function getSelectedVehicleId() {
        const selectorSection = getSelectorSection();
        const selectedVehicle = selectorSection?.dataset?.selectedVehicle;
        if (!selectedVehicle) return null;

        try {
            const v = JSON.parse(selectedVehicle);
            const id = Number(v?.vehicleId ?? v?.VehicleId);
            return Number.isFinite(id) && id > 0 ? id : null;
        } catch {
            return null;
        }
    }

    function getSelectedProductItemNumber() {
        const selectorSection = getSelectorSection();
        const selectedProduct = selectorSection?.dataset?.selectedProduct;
        if (!selectedProduct) return null;

        try {
            const p = JSON.parse(selectedProduct);
            // Try common shapes (camelCase / PascalCase)
            return (
                p?.mainComponent?.item?.itemNumber ??
                p?.MainComponent?.Item?.ItemNumber ??
                null
            );
        } catch {
            return null;
        }
    }

    function getOptionRadios(stepHost) {
        return Array.from(stepHost.querySelectorAll('input.js-product-option-radio[type="radio"]'));
    }

    function getSelectedComponents(stepHost) {
        // Selected radios (one per group)
        return getOptionRadios(stepHost)
            .filter(r => r.checked)
            .map(r => (r.value ?? '').trim())
            .filter(Boolean);
    }

    async function fetchProductOptions(itemNumber, vehicleId, selectedComponents) {
        const url = new URL('/api/product-selector/productOptions', window.location.origin);
        url.searchParams.set('itemNumber', itemNumber);
        url.searchParams.set('vehicleId', String(vehicleId));
        for (const c of selectedComponents) url.searchParams.append('selectedComponents', c);


        const antiForgeryToken = getAntiForgeryToken();
        const res = await fetch(url.toString(), {
            headers: {
                'Accept': 'application/json',
                ...(antiForgeryToken ? { 'RequestVerificationToken': antiForgeryToken } : {})
            }
        });
        if (!res.ok) {
            const text = await res.text();
            throw new Error(`productOptions request failed (${res.status}): ${text}`);
        }
        return await res.json();
    }

    function groupKeyForRadio(radio) {
        // groups are already set by name="Selected_{ComponentTypeId}"
        return radio.getAttribute('name') ?? '';
    }

    function getFirstValidRadioInGroup(groupRadios) {
        return groupRadios.find(r =>
            !r.disabled &&
            !r.closest('.optional-item')?.classList.contains('optional-item-disabled')
        ) ?? null;
    }

    function applyOptionValidity(stepHost, productOptionsResponse) {
        const radios = getOptionRadios(stepHost);

        // Build lookup: `${componentTypeId}|${itemNumber}` => isValid
        const validMap = new Map();
        const options = productOptionsResponse?.productOptions ?? productOptionsResponse?.ProductOptions ?? [];
        for (const po of options) {
            const ctId =
                po?.component?.componentType?.componentTypeId ??
                po?.Component?.ComponentType?.ComponentTypeId;

            const item =
                po?.component?.item?.itemNumber ??
                po?.Component?.Item?.ItemNumber;

            const isValid = Boolean(po?.isValid ?? po?.IsValid);
            if (ctId != null && item) validMap.set(`${ctId}|${String(item)}`, isValid);
        }

        // Disable/uncheck invalid radios, enable valid ones, and update item classes
        for (const r of radios) {
            const name = r.getAttribute('name') ?? '';
            const match = /^Selected_(\d+)$/.exec(name);
            const ctId = match ? Number(match[1]) : null;

            const key = ctId != null ? `${ctId}|${String(r.value)}` : null;
            const isValid = key ? (validMap.get(key) ?? true) : true;


            if (!isValid && r.checked) r.checked = false;

            const itemDiv = r.closest('.optional-item');
            if (itemDiv) {
                itemDiv.classList.toggle('optional-item-disabled', !isValid);
                itemDiv.classList.toggle('optional-item-selected', isValid && r.checked);
            }
        }

        // For each group, if nothing is selected, select the first available valid option
        const byGroup = new Map();
        for (const r of radios) {
            const g = groupKeyForRadio(r);
            if (!g) continue;
            if (!byGroup.has(g)) byGroup.set(g, []);
            byGroup.get(g).push(r);
        }

        let anyAutoSelected = false;

        for (const groupRadios of byGroup.values()) {
            const hasSelection = groupRadios.some(r => r.checked);
            if (hasSelection) continue;

            const firstValid = getFirstValidRadioInGroup(groupRadios);
            if (firstValid) {
                firstValid.checked = true;
                const itemDiv = firstValid.closest('.optional-item');
                if (itemDiv) itemDiv.classList.add('optional-item-selected');
                anyAutoSelected = true;
            }
        }

        return anyAutoSelected;
    }

    async function refreshProductOptionsAndReconcile(stepHost) {
        const vehicleId = getSelectedVehicleId();
        const itemNumber = getSelectedProductItemNumber();
        if (!vehicleId || !itemNumber) return;

        // Loop to stabilize: selecting a new "first valid" can affect validity of other groups
        for (let guard = 0; guard < 5; guard++) {
            const selectedComponents = getSelectedComponents(stepHost);
            const response = await fetchProductOptions(itemNumber, vehicleId, selectedComponents);

            reconcileOptionalItems(stepHost, response);

            const autoSelected = applyOptionValidity(stepHost, response);
            if (!autoSelected) break;
        }
    }

    // When an option radio changes, recalc valid/invalid options from server
    document.addEventListener('change', async (e) => {
        const radio = e.target;
        if (!(radio instanceof HTMLInputElement)) return;
        if (!radio.matches('input.js-product-option-radio[type="radio"]')) return;

        const stepHost = document.querySelector('#product-selector-step');
        if (!stepHost) return;

        try {
            await refreshProductOptionsAndReconcile(stepHost);
        } catch (err) {
            console.error('Failed to refresh product options:', err);
        }
    });

    // Optional: run once when Option step loads (useful for back nav / initial validity)
    const originalInit = window.productSelectorInit;
    window.productSelectorInit = function () {
        originalInit?.();

        const stepHost = document.querySelector('#product-selector-step');
        if (!stepHost) return;

        // Only run if Option step markup is present
        if (stepHost.querySelector('input.js-product-option-radio[type="radio"]')) {
            refreshProductOptionsAndReconcile(stepHost).catch(err => console.error(err));
            syncOptionalItemSelectedClass(stepHost);
        }
    };

    function getCheckedOptionalItemNumbers(stepHost) {
        return Array.from(stepHost.querySelectorAll('input.js-optional-check[type="checkbox"]:checked'))
            .map(cb => (cb.value ?? '').trim())
            .filter(Boolean);
    }

    function getOptionalItemsContainer(stepHost) {
        // In your Razor, optional items are rendered under: .options-header -> .options-list
        // We find the .options-list that contains any js-optional-check inputs.
        const list = stepHost.querySelector('.options-list:has(input.js-optional-check)'); // modern browsers
        if (list) return list;

        // Fallback: find the first .options-list with js-optional-check (no :has support)
        const lists = Array.from(stepHost.querySelectorAll('.options-list'));
        return lists.find(x => x.querySelector('input.js-optional-check')) ?? null;
    }

    function renderOptionalItemRow(optionalItem, isChecked) {
        const itemNumber = String(optionalItem?.itemNumber ?? optionalItem?.ItemNumber ?? '');
        const enhancedDescription = String(
            optionalItem?.enhancedDescription
            ?? optionalItem?.EnhancedDescription
            ?? optionalItem?.description
            ?? optionalItem?.Description
            ?? ''
        );

        const checkboxId = `opt_${itemNumber}`.replaceAll(' ', '_');

        const wrapper = document.createElement('div');
        wrapper.className = 'optional-item';

        wrapper.innerHTML = `
                <input class="btn-check js-optional-check"
                       type="checkbox"
                       name="SelectedOption"
                       id="${checkboxId}"
                       value="${itemNumber}"
                       autocomplete="off" ${isChecked ? 'checked' : ''} />
                <label class="form-check-label form-input-label" for="${checkboxId}">
                    <span>
                        <span class="optional-header">${itemNumber} <span class="product-optional-item-description-label">${enhancedDescription}</span></span>
                    </span>
                </label>
            `;

        return wrapper;
    }

    function reconcileOptionalItems(stepHost, productOptionsResponse) {
        const container = getOptionalItemsContainer(stepHost);
        if (!container) return;

        const responseItems = productOptionsResponse?.optionalItems ?? productOptionsResponse?.OptionalItems ?? [];
        const nextItemNumbers = new Set(
            responseItems
                .map(x => String(x?.itemNumber ?? x?.ItemNumber ?? '').trim())
                .filter(Boolean)
        );

        // Preserve currently checked items if still present in the response
        const previouslyChecked = new Set(getCheckedOptionalItemNumbers(stepHost));

        // Remove items no longer present
        const existingCheckboxes = Array.from(container.querySelectorAll('input.js-optional-check[type="checkbox"]'));
        for (const cb of existingCheckboxes) {
            const val = (cb.value ?? '').trim();
            if (!nextItemNumbers.has(val)) {
                cb.closest('.optional-item')?.remove();
            }
        }

        // Add new items that aren't already rendered
        const existingValues = new Set(
            Array.from(container.querySelectorAll('input.js-optional-check[type="checkbox"]'))
                .map(cb => (cb.value ?? '').trim())
                .filter(Boolean)
        );

        for (const item of responseItems) {
            const itemNumber = String(item?.itemNumber ?? item?.ItemNumber ?? '').trim();
            if (!itemNumber || existingValues.has(itemNumber)) continue;

            const keepChecked = previouslyChecked.has(itemNumber);
            container.appendChild(renderOptionalItemRow(item, keepChecked));
        }

        // Re-apply checked state for those that remain
        for (const cb of Array.from(container.querySelectorAll('input.js-optional-check[type="checkbox"]'))) {
            const val = (cb.value ?? '').trim();
            cb.checked = previouslyChecked.has(val) && nextItemNumbers.has(val);
        }
    }

    // re-run reconciliation after options response
    document.addEventListener('productOptionsFetched', (e) => {
        const stepHost = document.querySelector('#product-selector-step');
        if (!stepHost) return;

        const response = e.detail?.response;
        if (!response) return;

        reconcileOptionalItems(stepHost, response);
    });

    function syncOptionalItemSelectedClass(stepHost) {
        stepHost
            .querySelectorAll('input.js-optional-check[type="checkbox"]')
            .forEach(cb => {
                const itemDiv = cb.closest('.optional-item');
                if (!itemDiv) return;

                itemDiv.classList.toggle('optional-item-selected', cb.checked);
            });
    }

    // Toggle selected styling on optional item checkbox change
    document.addEventListener('change', (e) => {
        const cb = e.target;
        if (!(cb instanceof HTMLInputElement)) return;
        if (!cb.matches('input.js-optional-check[type="checkbox"]')) return;

        const itemDiv = cb.closest('.optional-item');
        if (!itemDiv) return;

        itemDiv.classList.toggle('optional-item-selected', cb.checked);
    });


    const emailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    function setEmailError(message) {
        const emailError = document.getElementById('emailError');
        const group = document.getElementById('form-group-email');
        if (emailError) {
            emailError.textContent = message || '';
            emailError.style.display = message ? '' : 'none';
        }
        if (group) group.classList.toggle('has-error', Boolean(message));
    }

    function resetEmailModal() {
        const form = document.getElementById('emailForm');
        const success = document.getElementById('emailSuccess');
        const input = document.getElementById('email_address');

        if (success) success.style.display = 'none';
        if (form) form.style.display = '';
        if (input instanceof HTMLInputElement) input.value = '';

        setEmailError('');
    }

    async function sendProductSelectorEmail(sendEmailAddress) {
        const ctx = getStepContext();
        if (!ctx) return;

        const { pageId } = ctx;

        const selectorSection = document.querySelector('#selector-section');
        if (!selectorSection) throw new Error('Missing selector-section.');

        const productApplication = safeParseJsonDataset(selectorSection, 'selectedProductApplication');
        if (!productApplication) throw new Error('Missing selectedProductApplication.');

        const antiForgeryToken = getAntiForgeryToken();

        const res = await fetch('/api/product-selector/sendEmail', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...(antiForgeryToken ? { 'RequestVerificationToken': antiForgeryToken } : {})
            },
            body: JSON.stringify({
                pageId: pageId,
                sendEmailAddress: sendEmailAddress,
                productApplication: productApplication,
            })
        });

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`sendEmail failed (${res.status}): ${text}`);
        }

        // Controller returns Ok(bool)
        return await res.json();
    }

    document.addEventListener('submit', async (e) => {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.id !== 'emailForm') return;

        e.preventDefault();

        const input = document.getElementById('email_address');
        if (!(input instanceof HTMLInputElement)) return;

        const email = (input.value ?? '').trim();

        // required
        if (!email) {
            setEmailError('Email address is required.');
            input.focus();
            return;
        }

        // regex
        if (!emailRegex.test(email)) {
            setEmailError('Please enter a valid email address.');
            input.focus();
            return;
        }

        setEmailError('');

        const submitBtn = document.getElementById('submitForm');
        if (submitBtn instanceof HTMLButtonElement) submitBtn.disabled = true;

        try {
            const ok = await sendProductSelectorEmail(email);

            if (ok === true) {
                const sub = document.getElementById('emailSentSubheader');
                if (sub) {
                    const template = sub.getAttribute('data-template') || '';
                    sub.textContent = template.replace(/\{0\}/g, email);
                }

                const success = document.getElementById('emailSuccess');
                if (success) success.style.display = '';

                form.style.display = 'none';
            } else {
                setEmailError('Unable to send email. Please try again.');
            }
        } catch (err) {
            console.error(err);
            setEmailError('Unable to send email. Please try again.');
        } finally {
            if (submitBtn instanceof HTMLButtonElement) submitBtn.disabled = false;
        }
    });

    // Reset modal each time it opens/closes (Bootstrap 4/jQuery)
    if (window.jQuery) {
        window.jQuery(document).on('show.bs.modal', '#emailModal', resetEmailModal);
        window.jQuery(document).on('hidden.bs.modal', '#emailModal', resetEmailModal);
    }

    function getStepContext() {
        const stepHost = document.querySelector('#product-selector-step');
        const selectorSection = document.querySelector('#selector-section');
        const pageId = stepHost?.getAttribute('data-page-id') ?? null;
        return (stepHost && selectorSection && pageId) ? { stepHost, selectorSection, pageId } : null;
    }

})();